// Mock data for Seltz Vodka Soda website

export const flavors = [
  {
    id: 'sour-cherry',
    name: 'cherry',
    description: 'Vișină intensă cu un echilibru perfect de dulce și acrișor. Prospătătoare și boldă.',
    color: '#d32f2f',
    textColor: '#ffffff',
    bgColor: '#fce4e4',
    image: '/assets/images/cherry.png',
    availableIn: ['seltz-sour-cherry'],
  },
  {
    id: 'peach',
    name: 'peach',
    description: 'Gust mare de piersică proaspătă, dulce și rotund, echilibrat cu bule fine.',
    color: '#ffcba4',
    textColor: '#cc6600',
    bgColor: '#ffecd2',
    image: '/assets/images/peach.png',
    availableIn: ['seltz-peach'],
  },
  {
    id: 'lime',
    name: 'lime',
    description: 'Lime proaspăt cu o dulceață subtilă și gust citric echilibrat. Ușor și revigorant.',
    color: '#b5e8a0',
    textColor: '#2d6a2d',
    bgColor: '#d4edda',
    image: '/assets/images/lime.png',
    availableIn: ['seltz-lime'],
  },
];

export const products = [
  {
    id: 'seltz-sour-cherry',
    name: 'seltz sour cherry',
    subtitle: 'Sour Cherry',
    description: 'Seltz Sour Cherry - vodcă premium cu aromă intensă de vișină.',
    longDescription: 'Seltz Sour Cherry combină vodcă premium cu aroma intensă de vișină pentru o experiență de gust unică. 86 de calorii, fără gluten.',
    price: 12.99,
    cans: 4,
    flavors: ['sour-cherry'],
    image: '/assets/images/three_cherry.png',
    badge: 'NEW',
    specs: '5% ABV • 86 Calories • 250ml',
    tags: ['premium vodka', 'natural flavours', 'low calories', 'gluten free'],
    active: true,
  },
  {
    id: 'seltz-peach',
    name: 'seltz peach',
    subtitle: 'Peach',
    description: 'Seltz Peach - vodcă premium cu gust autentic de piersică.',
    longDescription: 'Seltz Peach oferă gustul bogat și rotund al piersicii proaspete, echilibrat perfect cu bule fine. 86 de calorii, fără gluten.',
    price: 12.99,
    cans: 4,
    flavors: ['peach'],
    image: '/assets/images/three_peach.png',
    badge: 'NEW',
    specs: '5% ABV • 86 Calories • 250ml',
    tags: ['premium vodka', 'natural flavours', 'low calories', 'gluten free'],
    active: true,
  },
  {
    id: 'seltz-lime',
    name: 'seltz lime',
    subtitle: 'Lime',
    description: 'Seltz Lime - vodcă premium cu prospețime de lime.',
    longDescription: 'Seltz Lime aduce prospețimea lime-ului într-o combinație perfectă cu vodcă premium. Ușor, revigorant, 86 de calorii.',
    price: 12.99,
    cans: 4,
    flavors: ['lime'],
    image: '/assets/images/three_lime.png',
    badge: 'NEW',
    specs: '5% ABV • 86 Calories • 250ml',
    tags: ['premium vodka', 'natural flavours', 'low calories', 'gluten free'],
    active: true,
  },
];

export const features = [
  {
    id: 'natural-flavours',
    title: 'natural flavours',
    description: 'arome naturale autentice din ingrediente selectate cu grijă',
  },
  {
    id: 'premium-vodka',
    title: 'premium vodka',
    description: 'distilată fin, netedă și rafinată până la perfecțiune',
  },
  {
    id: 'bold-taste',
    title: 'bold taste',
    description: 'creată din ingrediente de calitate pentru un gust delicios și intens',
  },
  {
    id: 'low-calories',
    title: 'low calories',
    description: '86 de calorii, fără gluten',
  },
];

export const stores = [
  {
    id: 1,
    name: 'Mega Image Concept Store',
    address: 'Str. Barbu Văcărescu 120, București',
    lat: 44.4635,
    lng: 26.1044,
  },
  {
    id: 2,
    name: 'Dristor Kebap ParkLake',
    address: 'Str. Liviu Rebreanu 4, București',
    lat: 44.4212,
    lng: 26.1495,
  }
];

export const instagramPosts = [
  { id: 1, image: '/assets/images/three_peach.png', likes: 452 },
  { id: 2, image: '/assets/images/three_lime.png', likes: 389 },
  { id: 3, image: '/assets/images/three_cherry.png', likes: 512 },
  { id: 4, image: '/assets/images/all_flavors.png', likes: 856 },
  { id: 5, image: '/assets/images/peach.png', likes: 342 },
  { id: 6, image: '/assets/images/cherry.png', likes: 178 },
];
